export const CalendarDateFormats: { [key: string]: (date: Date) => string } = {
  "Tuesday, 24th April 2023": (date) =>
    `${date.toLocaleDateString("en-us", { weekday: "long" })}, ${date.getDate()}${nth(date.getDate())} ${date.toLocaleDateString("en-us", { month: "long" })} ${date.getFullYear()}`,
  "Tuesday, 24 April 2023": (date) =>
    `${date.toLocaleDateString("en-us", { weekday: "long" })}, ${padDate(date.getDate())} ${date.toLocaleDateString("en-us", { month: "long" })} ${date.getFullYear()}`,
  "24 April 2023": (date) =>
    `${padDate(date.getDate())} ${date.toLocaleDateString("en-us", { month: "long" })} ${date.getFullYear()}`,
  "24 Apr 2023": (date) =>
    `${padDate(date.getDate())} ${date.toLocaleDateString("en-us", { month: "short" })} ${date.getFullYear()}`,
  "04/24/2023 (MM/DD/YYYY)": (date) =>
    `${padDate(date.getMonth() + 1)}/${padDate(date.getDate())}/${date.getFullYear()}`,
  "24/04/2023 (DD/MM/YYYY)": (date) =>
    `${padDate(date.getDate())}/${padDate(date.getMonth() + 1)}/${date.getFullYear()}`,
};

const nth = function (d: number) {
  if (d > 3 && d < 21) return "th";
  switch (d % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const padDate = function (n: number) {
  return String(n).padStart(2, "0");
};
